/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TaxesResource
 */
export interface TaxesResource {
    /**
     * 
     * @type {string}
     * @memberof TaxesResource
     */
    companyTypeTaxId?: string;
    /**
     * 
     * @type {number}
     * @memberof TaxesResource
     */
    percent?: number;
    /**
     * 
     * @type {string}
     * @memberof TaxesResource
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof TaxesResource
     */
    taxType?: string;
    /**
     * 
     * @type {string}
     * @memberof TaxesResource
     */
    descriptionKey?: string;
}

/**
 * Check if a given object implements the TaxesResource interface.
 */
export function instanceOfTaxesResource(value: object): value is TaxesResource {
    return true;
}

export function TaxesResourceFromJSON(json: any): TaxesResource {
    return TaxesResourceFromJSONTyped(json, false);
}

export function TaxesResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): TaxesResource {
    if (json == null) {
        return json;
    }
    return {
        
        'companyTypeTaxId': json['companyTypeTaxId'] == null ? undefined : json['companyTypeTaxId'],
        'percent': json['percent'] == null ? undefined : json['percent'],
        'description': json['description'] == null ? undefined : json['description'],
        'taxType': json['taxType'] == null ? undefined : json['taxType'],
        'descriptionKey': json['descriptionKey'] == null ? undefined : json['descriptionKey'],
    };
}

export function TaxesResourceToJSON(value?: TaxesResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'companyTypeTaxId': value['companyTypeTaxId'],
        'percent': value['percent'],
        'description': value['description'],
        'taxType': value['taxType'],
        'descriptionKey': value['descriptionKey'],
    };
}

